import React, { useState } from 'react';
import { analytics } from '@sendgrid/bloodhound';
import { AccountInputsEvents } from '../analytics/accountInputsEvents';
import { TextInput } from '@sendgrid/ui-components/text-input';
import validationRules from '../constants/validationRules';
import errorTypes from '../constants/errorTypes';
const ViewIcon = require('../images/icons/view.svg');
const HideIcon = require('../images/icons/hide.svg');
const Styles = require('./passwordInput.module.scss');

interface PasswordInputProps {
  value: string;
  errorInfo: string;
  onChange: (e: React.FormEvent<HTMLInputElement>, value: string) => void;
  onBlur: (e: FocusEvent, value: string) => void;
  passwordLengthOnlyValidation?: boolean;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  value,
  errorInfo,
  onChange,
  onBlur,
  passwordLengthOnlyValidation,
  ...passThroughProps
}) => {
  const isValid = !errorInfo;
  const [showPassword, setShowPassword] = useState(false);
  const onToggleViewPassword = () => {
    setShowPassword(!showPassword);
    analytics.track(AccountInputsEvents.revealPasswordToggled);
  };
  const defaultShortMessage = `Must ${errorTypes.PASSWORD_SHORT}`
  const defaultMessage = passwordLengthOnlyValidation ? `${defaultShortMessage}.` : `${defaultShortMessage}, including at least 1 letter and number.`

  return (
    <TextInput
      type={showPassword ? 'text' : 'password'}
      label="Password"
      isRequired
      isValid={isValid}
      id="password"
      info={
        errorInfo || defaultMessage
      }
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      {...passThroughProps}
    >
      <img
        className={Styles['input-password-toggle']}
        src={showPassword ? HideIcon : ViewIcon}
        onClick={onToggleViewPassword}
        data-role="password-toggle"
        tabIndex={0}
      />
    </TextInput>
  );
};

export default PasswordInput;
